'use strict'; // @ts-ignore nat-api does not export types

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectWithoutProperties = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _excluded = ["peerId", "addressManager", "transportManager"];

var NatAPI = require('@motrix/nat-api');

var debug = require('debug');

var _require = require('es6-promisify'),
    promisify = _require.promisify;

var _require2 = require('multiaddr'),
    Multiaddr = _require2.Multiaddr;

var log = Object.assign(debug('libp2p:nat'), {
  error: debug('libp2p:nat:err')
});

var _require3 = require('wherearewe'),
    isBrowser = _require3.isBrowser;

var retry = require('p-retry'); // @ts-ignore private-api does not export types


var isPrivateIp = require('private-ip');

var pkg = require('../package.json');

var errcode = require('err-code');

var _require4 = require('./errors'),
    ERR_INVALID_PARAMETERS = _require4.codes.ERR_INVALID_PARAMETERS;

var isLoopback = require('libp2p-utils/src/multiaddr/is-loopback');

var DEFAULT_TTL = 7200;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('./transport-manager')} TransportManager
 * @typedef {import('./address-manager')} AddressManager
 */

/**
 * @typedef {Object} NatManagerProperties
 * @property {PeerId} peerId - The peer ID of the current node
 * @property {TransportManager} transportManager - A transport manager
 * @property {AddressManager} addressManager - An address manager
 *
 * @typedef {Object} NatManagerOptions
 * @property {boolean} enabled - Whether to enable the NAT manager
 * @property {string} [externalIp] - Pass a value to use instead of auto-detection
 * @property {string} [description] - A string value to use for the port mapping description on the gateway
 * @property {number} [ttl = DEFAULT_TTL] - How long UPnP port mappings should last for in seconds (minimum 1200)
 * @property {boolean} [keepAlive] - Whether to automatically refresh UPnP port mappings when their TTL is reached
 * @property {string} [gateway] - Pass a value to use instead of auto-detection
 * @property {object} [pmp] - PMP options
 * @property {boolean} [pmp.enabled] - Whether to enable PMP as well as UPnP
 */

function highPort() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1024;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 65535;
  return Math.floor(Math.random() * (max - min + 1) + min);
}

var NatManager = /*#__PURE__*/function () {
  /**
   * @class
   * @param {NatManagerProperties & NatManagerOptions} options
   */
  function NatManager(_ref) {
    var peerId = _ref.peerId,
        addressManager = _ref.addressManager,
        transportManager = _ref.transportManager,
        options = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, NatManager);

    this._peerId = peerId;
    this._addressManager = addressManager;
    this._transportManager = transportManager;
    this._enabled = options.enabled;
    this._externalIp = options.externalIp;
    this._options = {
      description: options.description || "".concat(pkg.name, "@").concat(pkg.version, " ").concat(this._peerId),
      ttl: options.ttl || DEFAULT_TTL,
      autoUpdate: options.keepAlive || true,
      gateway: options.gateway,
      enablePMP: Boolean(options.pmp && options.pmp.enabled)
    };

    if (this._options.ttl < DEFAULT_TTL) {
      throw errcode(new Error("NatManager ttl should be at least ".concat(DEFAULT_TTL, " seconds")), ERR_INVALID_PARAMETERS);
    }
  }
  /**
   * Starts the NAT manager
   */


  _createClass(NatManager, [{
    key: "start",
    value: function start() {
      if (isBrowser || !this._enabled) {
        return;
      } // done async to not slow down startup


      this._start().catch(function (err) {
        // hole punching errors are non-fatal
        log.error(err);
      });
    }
  }, {
    key: "_start",
    value: function () {
      var _start2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var addrs, _iterator, _step, addr, _addr$toOptions, family, host, port, transport, client, publicIp, publicPort;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                addrs = this._transportManager.getAddrs();
                _iterator = _createForOfIteratorHelper(addrs);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 29;
                  break;
                }

                addr = _step.value;
                // try to open uPnP ports for each thin waist address
                _addr$toOptions = addr.toOptions(), family = _addr$toOptions.family, host = _addr$toOptions.host, port = _addr$toOptions.port, transport = _addr$toOptions.transport;

                if (!(!addr.isThinWaistAddress() || transport !== 'tcp')) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("continue", 27);

              case 9:
                if (!isLoopback(addr)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("continue", 27);

              case 11:
                if (!(family !== 4)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("continue", 27);

              case 13:
                client = this._getClient();
                _context.t0 = this._externalIp;

                if (_context.t0) {
                  _context.next = 19;
                  break;
                }

                _context.next = 18;
                return client.externalIp();

              case 18:
                _context.t0 = _context.sent;

              case 19:
                publicIp = _context.t0;

                if (!isPrivateIp(publicIp)) {
                  _context.next = 22;
                  break;
                }

                throw new Error("".concat(publicIp, " is private - please set config.nat.externalIp to an externally routable IP or ensure you are not behind a double NAT"));

              case 22:
                publicPort = highPort();
                log("opening uPnP connection from ".concat(publicIp, ":").concat(publicPort, " to ").concat(host, ":").concat(port));
                _context.next = 26;
                return client.map({
                  publicPort: publicPort,
                  privatePort: port,
                  protocol: transport.toUpperCase()
                });

              case 26:
                this._addressManager.addObservedAddr(Multiaddr.fromNodeAddress({
                  family: 4,
                  address: publicIp,
                  port: publicPort
                }, transport));

              case 27:
                _context.next = 4;
                break;

              case 29:
                _context.next = 34;
                break;

              case 31:
                _context.prev = 31;
                _context.t1 = _context["catch"](2);

                _iterator.e(_context.t1);

              case 34:
                _context.prev = 34;

                _iterator.f();

                return _context.finish(34);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 31, 34, 37]]);
      }));

      function _start() {
        return _start2.apply(this, arguments);
      }

      return _start;
    }()
  }, {
    key: "_getClient",
    value: function _getClient() {
      if (this._client) {
        return this._client;
      }

      var client = new NatAPI(this._options);
      /** @type {(...any: any) => any} */

      var _map = promisify(client.map.bind(client));
      /** @type {(...any: any) => any} */


      var _destroy = promisify(client.destroy.bind(client));
      /** @type {(...any: any) => any} */


      var _externalIp = promisify(client.externalIp.bind(client)); // these are all network operations so add a retry


      this._client = {
        /**
         * @param  {...any} args
         * @returns {Promise<void>}
         */
        map: function map() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return retry(function () {
            return _map.apply(void 0, args);
          }, {
            onFailedAttempt: log.error,
            unref: true
          });
        },

        /**
         * @param  {...any} args
         * @returns {Promise<void>}
         */
        destroy: function destroy() {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return retry(function () {
            return _destroy.apply(void 0, args);
          }, {
            onFailedAttempt: log.error,
            unref: true
          });
        },

        /**
         * @param  {...any} args
         * @returns {Promise<string>}
         */
        externalIp: function externalIp() {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          return retry(function () {
            return _externalIp.apply(void 0, args);
          }, {
            onFailedAttempt: log.error,
            unref: true
          });
        }
      };
      return this._client;
    }
    /**
     * Stops the NAT manager
     *
     * @async
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(isBrowser || !this._client)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return this._client.destroy();

              case 5:
                this._client = null;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                log.error(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }]);

  return NatManager;
}();

module.exports = NatManager;